import type { CSSProperties } from 'react';
import { ConnectionPill } from './bits';
import { useAppEnv } from './context';
import { isMacLike } from './shell';
import { hostOf } from '../format';

const drag = { WebkitAppRegion: 'drag' } as CSSProperties;
const noDrag = { WebkitAppRegion: 'no-drag' } as CSSProperties;

/**
 * Title bar: company · address, search pill and connection status. On the
 * desktop the real window controls are native (macOS traffic lights or the
 * Windows/Linux overlay) — this bar only leaves room and acts as the drag
 * region. Never draws fake window controls; hidden when the OS draws a frame.
 */
export function Titlebar({ onSearch }: { onSearch(): void }) {
  const { appInfo, servers, activeServerId } = useAppEnv();
  const titlebar = appInfo.titlebar;
  if (titlebar.kind === 'native') return null;
  const server = servers.find((s) => s.serverId === activeServerId);
  const desktopFrame = titlebar.kind === 'mac-inset' || titlebar.kind === 'overlay';
  return (
    <header className="titlebar" role="banner" style={desktopFrame ? { ...drag, paddingLeft: 16 + titlebar.leftInset, paddingRight: 16 + titlebar.rightInset } : undefined}>
      <div className="tb-title">
        <span>{server?.companyName ?? ''}</span>
        <span className="srvaddr">{server ? hostOf(server.serverUrl) : ''}</span>
      </div>
      <div className="tb-right" style={desktopFrame ? { ...noDrag, right: 12 + titlebar.rightInset } : undefined}>
        <button type="button" className="tb-search" onClick={onSearch} aria-label="전체 검색 열기">
          검색 <span className="kbd">{isMacLike() ? '⌘K' : 'Ctrl K'}</span>
        </button>
        <ConnectionPill />
      </div>
    </header>
  );
}
